export default __webpack_public_path__ + "static/media/teddy_simple.4ee4aab4.svg";